import get from 'lodash/get';
import * as Api from '../api';
import * as Mappers from '../mappers';
import * as Types from '../types';

interface IProps {
  params?: Types.IApi.List.Params;
}

const List = ({
  params,
}: IProps): [string[], () => Promise<Types.IQuery.List>] => [
  ['test', 'list', JSON.stringify(params)],
  async () => {
    const { data } = await Api.List(params);

    const items = (get(data, 'data.items') || []).map(Mappers.Test);
    const meta = Mappers.Meta(get(data, 'data.meta'));

    return {
      items,
      meta,
    };
  },
];

export default List;
